export enum GuideStatus {
  Draft = 'GuideStatus_Draft',
  Pending = 'GuideStatus_Pending',
  Approved = 'GuideStatus_Approved',
  Declined = 'GuideStatus_Declined',
  Archived = 'GuideStatus_Archived'
}
